import { useState, useEffect, useRef, useCallback } from 'react';

const useTimeCounter = (initialTime, autoStart = true) => {
  const [timeLeft, setTimeLeft] = useState(autoStart ? initialTime : 0);
  const intervalRef = useRef(null);

  const stopCountdown = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);

  const startCountdown = useCallback(
    (time = initialTime) => {
      setTimeLeft(time);
      stopCountdown();

      intervalRef.current = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            stopCountdown();
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
    },
    [initialTime, stopCountdown]
  );

  useEffect(() => {
    if (autoStart) {
      startCountdown();
    }
    return stopCountdown;
  }, [autoStart, startCountdown, stopCountdown]);

  return [timeLeft, startCountdown, stopCountdown];
};

export default useTimeCounter;
